module.exports = __webpack_public_path__ + "img/ia03.25062bc5.png";